var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ListView",on:{"click":function($event){return _vm.listClick()}}},[_vm._t("default"),_c('i',{staticClass:"el-icon-arrow-right"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }